'use strict';

export abstract class Entity {
  protected id: number;

  constructor() {}

  public getId() {
    return this.id;
  }
}
